export default {
  computed: {
    works () {
      return this.$store.getters.works
    },
    worksLoading: {
      get () {
        return this.$store.getters.worksLoading
      }
    },
    worksTotal: {
      get () {
        return parseInt(this.$store.getters.worksTotal);
      }
    },
    is_empty_filters: {
      get () {
        return this.$store.getters.is_empty_filters
      }
    },

    //+для субдоменов
    plceholder_src(){
      return window._GL_SITE_URL_CDN+'/res7/img/placeholders/collection.svg';
    },
  },
}



//////////////////
// WEBPACK FOOTER
// ./src/components/WorksComputedMix.js
// module id = null
// module chunks = 